document.documentElement.classList.remove('no-js');
document.documentElement.classList.add('js');
(() => {
  const header = document.querySelector('.sh-header--launch');
  if (!header) return;
  const toggle = header.querySelector('.sh-launch-toggle');
  const nav = header.querySelector('#SEOHelpNav');
  if (!toggle || !nav) return;
  const disclosures = [...nav.querySelectorAll('.sh-launch-disclosure')];
  const closeDisclosures = (except) => disclosures.forEach((item) => {
    if (item !== except) item.open = false;
  });
  const closeMenu = () => {
    nav.classList.remove('is-open');
    toggle.setAttribute('aria-expanded', 'false');
    closeDisclosures();
  };
  const updateHeight = () => {
    const height = Math.ceil(header.getBoundingClientRect().height);
    header.style.setProperty('--sh-header-height', `${height}px`);
    document.documentElement.style.setProperty('scroll-padding-top', getComputedStyle(header).position === 'sticky' ? `${height + 12}px` : '16px');
  };
  updateHeight();
  if ('ResizeObserver' in window) new ResizeObserver(updateHeight).observe(header);
  else window.addEventListener('resize', updateHeight, { passive: true });
  toggle.addEventListener('click', () => {
    const open = toggle.getAttribute('aria-expanded') !== 'true';
    nav.classList.toggle('is-open', open);
    toggle.setAttribute('aria-expanded', String(open));
    if (!open) closeDisclosures();
  });
  disclosures.forEach((item) => item.addEventListener('toggle', () => {
    if (item.open) closeDisclosures(item);
  }));
  nav.addEventListener('click', (event) => {
    if (event.target.closest('a')) closeMenu();
  });
  document.addEventListener('click', (event) => {
    if (!header.contains(event.target)) closeMenu();
  });
  document.addEventListener('focusin', (event) => {
    if (!header.contains(event.target)) closeMenu();
    else disclosures.forEach((item) => {
      if (!item.contains(event.target)) item.open = false;
    });
  });
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const active = disclosures.find((item) => item.open && item.contains(document.activeElement));
    if (active) {
      active.open = false;
      active.querySelector('summary').focus();
    } else if (toggle.getAttribute('aria-expanded') === 'true') {
      closeMenu();
      toggle.focus();
    } else closeDisclosures();
  });
  window.matchMedia('(min-width: 1021px)').addEventListener('change', (event) => {
    const active = document.activeElement;
    const wasInNav = nav.contains(active);
    const disclosure = disclosures.find((item) => item.contains(active));
    closeMenu();
    if (!event.matches && wasInNav) toggle.focus();
    else if (event.matches && active === toggle) nav.querySelector('summary, a')?.focus();
    else if (event.matches && active?.closest('.sh-launch-utilities--mobile')) {
      const equivalent = [...nav.querySelectorAll('.sh-launch-utilities--desktop a')].find((link) => link.getAttribute('href') === active.getAttribute('href'));
      (equivalent || nav.querySelector('summary, a'))?.focus();
    }
    else if (event.matches && disclosure && active !== disclosure.querySelector('summary')) disclosure.querySelector('summary').focus();
    updateHeight();
  });
})();

(() => {
  const header = document.querySelector('.sh-header--launch');
  if (!header) return;
  const labels = header.dataset;
  const mobile = window.matchMedia('(max-width: 749px)');
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const symbols = { 'local-seo': 'local', 'national-seo': 'national', 'b2b-seo': 'b2b', 'google-business-profile': 'profile', 'seo-audits': 'audit', 'ai-search-discovery': 'ai', 'seo-migration': 'migration', 'ecommerce-seo': 'commerce', 'shopify-seo': 'commerce' };
  const selector = '.shh-service-grid,.shh-price-track,.shh-discovery-list,.shh-process ol,.nl-service-grid,.nl-prices,.nl-cards,.nl-benefits,.nl-process,.sh-insight-grid';
  let sequence = 0;
  const enhance = (root) => {
    root.querySelectorAll('.nl-service,.nl-card,.shh-discovery-list>article').forEach((card) => {
      const link = [...card.querySelectorAll('a[href]')].find((item) => symbols[item.getAttribute('href').replace('/pages/', '')]);
      if (!link) return;
      card.classList.add('sh-has-symbol', `sh-symbol-${symbols[link.getAttribute('href').replace('/pages/', '')]}`);
    });
    root.querySelectorAll(selector).forEach((track) => {
      if (track.dataset.carouselReady) return;
      const cards = [...track.children];
      if (cards.length < 2) return;
      track.dataset.carouselReady = 'true';
      track.classList.add('sh-carousel');
      track.id ||= `SEOHelpCarousel-${++sequence}`;
      const heading = track.closest('section')?.querySelector('h2,h3') || track.closest('main')?.querySelector('h1');
      const controls = document.createElement('div');
      controls.className = 'sh-carousel-controls';
      const hint = document.createElement('span');
      hint.className = 'sh-carousel-hint';
      hint.textContent = labels.carouselHint;
      const counter = document.createElement('span');
      counter.className = 'sh-carousel-counter';
      const makeButton = (label, direction) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'sh-carousel-control';
        button.setAttribute('aria-label', label);
        button.setAttribute('aria-controls', track.id);
        const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
        svg.setAttribute('viewBox', '0 0 24 24');
        svg.setAttribute('fill', 'none');
        svg.setAttribute('aria-hidden', 'true');
        const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
        path.setAttribute('d', direction < 0 ? 'M19 12H5m5-5-5 5 5 5' : 'M5 12h14m-5-5 5 5-5 5');
        path.setAttribute('stroke', 'currentColor');
        path.setAttribute('stroke-width', '2');
        path.setAttribute('stroke-linecap', 'round');
        path.setAttribute('stroke-linejoin', 'round');
        svg.append(path);
        button.append(svg);
        return button;
      };
      const previous = makeButton(labels.carouselPrevious, -1);
      const next = makeButton(labels.carouselNext, 1);
      controls.append(hint, counter, previous, next);
      track.before(controls);
      let index = 0;
      let frame = 0;
      const update = () => {
        frame = 0;
        if (!mobile.matches) return;
        const start = track.getBoundingClientRect().left;
        index = cards.reduce((nearest, card, i) => Math.abs(card.getBoundingClientRect().left - start) < Math.abs(cards[nearest].getBoundingClientRect().left - start) ? i : nearest, 0);
        if (track.scrollLeft >= track.scrollWidth - track.clientWidth - 3) index = cards.length - 1;
        counter.textContent = `${index + 1} / ${cards.length}`;
        counter.setAttribute('aria-label', labels.carouselPosition.replace('{current}', index + 1).replace('{total}', cards.length));
        previous.disabled = index === 0;
        next.disabled = index === cards.length - 1;
      };
      const move = (direction) => {
        const target = Math.max(0, Math.min(cards.length - 1, index + direction));
        const left = track.scrollLeft + cards[target].getBoundingClientRect().left - track.getBoundingClientRect().left;
        track.scrollTo({ left, behavior: reduced.matches ? 'instant' : 'smooth' });
      };
      previous.addEventListener('click', () => move(-1));
      next.addEventListener('click', () => move(1));
      track.addEventListener('scroll', () => { if (!frame) frame = requestAnimationFrame(update); }, { passive: true });
      track.addEventListener('keydown', (event) => {
        if (event.target !== track || !mobile.matches) return;
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') { event.preventDefault(); move(event.key === 'ArrowRight' ? 1 : -1); }
      });
      const setMode = () => {
        if (mobile.matches) {
          track.setAttribute('tabindex', '0');
          if (!['UL', 'OL'].includes(track.tagName)) track.setAttribute('role', 'region');
          track.setAttribute('aria-label', heading?.textContent.trim() || labels.carouselHint);
          requestAnimationFrame(update);
        } else {
          track.removeAttribute('tabindex');
          if (!['UL', 'OL'].includes(track.tagName)) track.removeAttribute('role');
          track.removeAttribute('aria-label');
        }
      };
      mobile.addEventListener('change', setMode);
      setMode();
    });
  };
  enhance(document);
  document.addEventListener('shopify:section:load', (event) => enhance(event.target));
})();
